<template>
  <div class="chats">
    <div
      v-for="(msgGrp, index) in formattedChatData.formattedChatLog"
      :key="msgGrp.senderId + String(index)"
      class="chat"
      :class="{ 'chat-left': msgGrp.senderId == formattedChatData.contact.id }"
    >
      <div class="chat-avatar">
        <b-avatar
          size="36"
          class="avatar-border-2 box-shadow-1"
          variant="transparent"
          :src="
            msgGrp.senderId === formattedChatData.contact.id
              ? formattedChatData.contact.avatar
              : profileUserAvatar
          "
        />
      </div>
      <div class="chat-body">
        <div v-for="msgData in msgGrp.messages" :key="msgData._id" class="chat-content">
          <p>{{ msgData.msg }}</p>
          <div class="text-right text-muted text-sm">{{ msgData.time }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import { BAvatar } from "bootstrap-vue";
import moment from "moment";

export default {
  components: {
    BAvatar,
  },
  props: {
    chatData: {
      type: Object,
      required: true,
    },
    profileUserAvatar: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const formattedChatData = computed(() => {
      const contact = {
        id: props.chatData.contact.id,
        avatar: props.chatData.contact.avatar,
      };

      /* let chatLog = []
      if (props.chatData.chat) {
        chatLog = props.chatData.chat.chat
      } */

      let chatLog = [];
      if (props.chatData.messages) {
        chatLog = props.chatData.messages;
      }

      const formattedChatLog = [];
      let chatMessageSenderId = chatLog[0] ? chatLog[0].senderId : undefined;
      let msgGroup = {
        senderId: chatMessageSenderId,
        messages: [],
      };

      chatLog.forEach((msg, index) => {
        if (chatMessageSenderId === msg.senderId) {
          msgGroup.messages.push({
            msg: msg.messageBody,
            time: moment(msg.createdAt).format("MMM d, Y h:mm A"),
          });
        } else {
          chatMessageSenderId = msg.senderId;
          formattedChatLog.push(msgGroup);
          msgGroup = {
            senderId: msg.senderId,
            messages: [
              {
                msg: msg.messageBody,
                time: moment(msg.createdAt).format("MMM d, Y h:mm a"),
              },
            ],
          };
        }
        if (index === chatLog.length - 1) formattedChatLog.push(msgGroup);
      });

      return {
        formattedChatLog,
        contact,
        profileUserAvatar: props.profileUserAvatar,
      };
    });

    return {
      formattedChatData,
    };
  },
};
</script>

<style scoped>
.text-sm {
  font-size: 11px;
}
</style>
